import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';

const getLinesOfCell = (count, lines, x, y) => {
	const al = [];
	for(let l of lines) {
		if((l.x===x || l.x===x+1) && l.y===y && l.isH || l.x===x && (l.y===y || l.y===y+1) && !l.isH) {
			al.push(l);
		}
	}
	return al;
}

const getCells = (count, lines, existingCells) => {
	const cells = [];
	for(let i=0; i<count; i++) {
		for(let j=0; j<count; j++) {
			const ls = getLinesOfCell(count, lines, i, j);
			if(ls.length===4) {
				let latestLine = null;
				for(const line of ls) {
					if(!latestLine || line.time > latestLine.time)
						latestLine = line;
				}
				cells.push({x: i, y: j, pid: latestLine.pid});
			}
		}
	}
	if(existingCells) {
		const newCells = [];
		for(let i of cells) {
			if(!existingCells.find(j => j.x===i.x && j.y===i.y))
				newCells.push(i);
		}
		return newCells;
	}
	return cells;
}

export default function Game({controller, reset}) {
	const ws = useRef(null);
	const [state, setState] = useState({
		init: false,
		connection: false,
		count: controller.count,
		sensors: false,
		turn: null,
		lines: [],
		cells: [],
		people: [],
	})
	const {connection, count, turn, lines, cells, people} = state;
	const pointsArr = useMemo(() => {
		const ar = [];
		for(let i=0; i<=count; i++) {
			ar.push(i)
		}
		return ar;
	}, [count]);

	const tryMarkLine = (isH, x, y) => {
		sendMessage({type: 'line', line: {x, y, isH, pid: turn}});
		markLine(isH, x, y, turn);
	}
	const markLine = (isH, x, y, pid) => {
		setState(s => {
			const newLines = [...s.lines, {x, y, isH, pid, time: Date.now()}];
			const newCells = getCells(s.count, newLines, s.cells)
			return {...s, lines: newLines, sensors: false, cells: [...s.cells, ...newCells]};
		});
	}
	const markCell = (x, y, pid) => {
		setState(s => ({...s, cells: [...s.cells, {x, y, pid}]}))
	}


	const linesArr = useMemo(() => {
		const arh = [];
		const arv = [];
		for(let i=0; i<=count; i++) {
			const ar1h = [];
			const ar1v = [];
			for(let j=0; j<=count; j++) {
				if(j!==count)
					ar1h.push({selected: lines.find(l => l.isH && l.x===i && l.y===j)?true:false})
				if(i!==count)
					ar1v.push({selected: lines.find(l => !l.isH && l.x===i && l.y===j)?true:false})
			}
			arh.push(ar1h);
			arv.push(ar1v);
		}
		return {h: arh, v: arv};
	}, [count, lines]);
	
	const cellsArr = useMemo(() => {
		const ar = [];
		for(let i=0; i<count; i++) {
			const ar1 = [];
			for(let j=0; j<count; j++) {
				const selected = cells.find(c => c.x===i && c.y===j);
				const person = selected?people.find(i => i.pid===selected.pid):'';
				ar1.push({name: person?.name, selected: person?true:false, color: person?.color})
			}
			ar.push(ar1);
		}
		return ar;
	}, [count, cells, people]);
	const scoresArr = useMemo(() => {
	}, [cells, people]);


	const sendMessage = (obj) => {
		controller.send(obj);
	}


	useEffect(() => {
		if(controller.setup) return
		controller.setup = true;
		controller.addEventListener('open', () => {
			controller.init();
			setState(s => ({...s, connection: true, init: true}));
		});
		controller.addEventListener('close', () => {
			setState(s => ({...s, connection: false}));
		})
		controller.addEventListener('message', (e) => {
			const data = e.data;
			if(data.type==='accepted') {
				setState(s => ({
					...s,
					url: controller.url,
					people: [...s.people, data.person],
					count: data.game.count,
				}))
			} else if(data.type==='person')
				setState(s => ({...s, people: [...s.people, data.person].sort((a,b) => a.pid-b.pid)}));
			else if(data.type==='line')
				markLine(data.line.isH, data.line.x, data.line.y, data.line.pid)
			else if(data.type==='turn')
				setState(s => ({...s, turn: data.pid, sensors: data.sensors || false}));
			else if(data.type==='dead')
				setState(s => ({...s, people: s.people.map(p => ({...p, dead: p.dead || p.pid===data.pid}))}));
		})
	}, [])
	useEffect(() => {
		if(cells.length===count*count) {
			const score = {count: 0, person: null}
			for(let p of people) {
				let pc = 0;
				for(let c of cells) {
					if(c.pid===p.pid)
						pc++;
				}
				if(pc > score.count) {
					score.count = pc;
					score.person = p;
				}
			}
			setState(s => ({...s, winner: score.person}))
		}
	}, [cells, count, people]);


	return (
		<>
			<div className="outer-container">
				<div className="tip">
					{!lines.length && state.sensors?(
					"Mark a line to start the game."
					):state.winner?(state.winner.self ? "You" : state.winner.name)+' won the game!':null}
				</div>
				<div className="game-outer card">
					<div className="main-container" style={{height: (pointsArr.length-1)*50, width: (pointsArr.length-1)*50}}>
						<div className="container cell-container">
							{cellsArr.map((i,ii) => (
								i.map((j,jj) => (
									<div
										key={jj+'_'+ii}
										className={`cell${j.selected?' selected':''}`}
										style={{left: ii*50, top: jj*50, backgroundColor: j.color}}
									/>
								))
							))}
						</div>
						<div className="container dot-container">
							{pointsArr.map((i,ii) => (
								pointsArr.map((j,jj) => (
									<div key={jj+'_'+ii} className="dot" style={{top: j*50, left: i*50}} />
								))
							))}
						</div>
						<div className="container line-container" style={{pointerEvents: state.sensors?'all':'none'}}>
							{linesArr.h.map((i,ii) => (
								i.map((j,jj) => (
									<div key={jj+'_'+ii} className={`line vertical${j.selected?' selected':''}${ii===lines[lines.length-1]?.x&&jj===lines[lines.length-1]?.y&&lines[lines.length-1]?.isH?' latest':''}`} style={{left: ii*50, top: jj*50}} onClick={() => tryMarkLine(true, ii, jj)} />
								))
							))}
							{linesArr.v.map((i,ii) => (
								i.map((j,jj) => (
									<div key={jj+'_'+ii} className={`line horizontal${j.selected?' selected':''}${ii===lines[lines.length-1]?.x&&jj===lines[lines.length-1]?.y&&!lines[lines.length-1]?.isH?' latest':''}`} style={{left: ii*50, top: jj*50}} onClick={() => tryMarkLine(false, ii, jj)} />
								))
							))}
						</div>
					</div>
				</div>
				<div className="people-list card">
					{people.map(i => (
						<div className={`person${i.pid===turn?' turn':''}`} key={i.pid}>
							<div className="colorbox" style={{background: i.color}} />
							<div className={`name${i.self?' self':''}${i.dead?' dead':''}`}>{i.name}</div>
							<div className="score">{cells.filter(c => c.pid===i.pid).length}</div>
						</div>
					))}
				</div>
				<div className="tip">
					{state.winner?(
						<button className="" onClick={() => reset()}>Start Again</button>
					):!state.lines.length && state.url?(
						<>Share the <a href={state.url || ''}>Game URL</a> to others to join.</>
					):null}
				</div>
			</div>
		{/*<canvas id="canvas" height="5000" width="5000" />*/}
			{!state.connection && state.init?(
				<div className="offline">OFFLINE</div>
			):null}
		</>
	)
}
